<div class="no-item-available">
    <figure>
        <img src="assets/images/No-Item-available.svg" alt="No Result Found"/>
    </figure>
    <div class="content">
        <h3 *ngIf="itemMsg">No Item available currently</h3>
        <h3 *ngIf="offerMsg">No coupons available at the moment. Please check back later.</h3>
        <p *ngIf="msg">We are working hard to make items available soon.</p>
    </div>
</div>